import { isClickEvent } from '../../utils/event.js';
import { isSpaceKey, isEnterKey } from '../../utils/keyboard.js';
import { useActive } from '../../utils/useActive/useActive.js';

function useGroup({ isActive, isDefaultOpen, isExpandable, onExpand }) {
    const { isActive: isOpen, toggleActive: toggleOpen } = useActive(isDefaultOpen);
    const isActiveOrOpen = isActive !== null && isActive !== void 0 ? isActive : isOpen;
    const handleExpand = (event) => {
        const isClickEventFired = isClickEvent(event);
        const isSpacePressed = isSpaceKey(event);
        const isEnterPressed = isEnterKey(event);
        const isKeyboardEvent = isSpacePressed || isEnterPressed;
        const canBeExpanded = isClickEventFired || isKeyboardEvent;
        if (isSpacePressed) {
            event.preventDefault();
        }
        if (isSpacePressed || isEnterPressed) {
            event.stopPropagation();
        }
        if (isExpandable && canBeExpanded) {
            if (onExpand) {
                onExpand(!isOpen);
            }
            toggleOpen();
        }
    };
    return {
        isOpen,
        isExpandable,
        isActiveOrOpen,
        handleExpand,
    };
}

export { useGroup };
//# sourceMappingURL=useGroup.js.map
